import MortandadView from "./MortandadView";
export default MortandadView;